import LoginLayout from "../../../components/layout/login-layout/login-layout";
import LoginForm from "./login-form";

const Login = () => {
  return <LoginLayout content={<LoginForm />} />;
};

export default Login;
